import { create } from "zustand";

interface SelectedYearState {
  selectedYear: number | null;
  setSelectedYear: (year: number) => void;
}

const useSelectedYearStore = create<SelectedYearState>((set) => ({
  selectedYear: null, // Must be set from URL/context before use
  setSelectedYear: (year: number) => set({ selectedYear: year }),
}));

export default useSelectedYearStore;
